/* Funtastic — cores-card 17/10: bolinhas de cor nos cartões (snippets/fs-sw.liquid).
   Rato por cima de uma bolinha (desktop): mostra a foto dessa cor e o link do cartão passa a ir para essa cor;
   ao sair do cartão volta à cor escolhida (clique) ou à original. Toque/clique/Enter: escolhe a cor (fica), sem sair da página.
   Não faz pedidos novos: só troca o src/srcset da foto para a imagem da outra cor (já no HTML). O fs-fit.js volta a enquadrar
   a foto no evento 'load'. */
(function(){
  'use strict';
  if (window.FSSw) return;
  function card(el){ return el && el.closest ? el.closest('[data-fs-swcard]') : null; }
  function pick(d){
    var c = card(d); if (!c) return;
    var url = d.getAttribute('data-url');
    if (url) Array.prototype.forEach.call(c.querySelectorAll('[data-fs-sw-lnk]'), function(a){ a.setAttribute('href', url); });
    var box = c.querySelector('[data-fs-sw-img]'), img = box && box.querySelector('img');
    var src = d.getAttribute('data-src'), ss = d.getAttribute('data-srcset');
    if (img && src && img.getAttribute('data-fs-sw-on') !== src){
      img.setAttribute('data-fs-sw-on', src);
      /* fs-fit: limpar o enquadramento da foto anterior; o 'load' da nova volta a medir */
      img.classList.remove('fs-fit'); img.classList.add('fs-fit-tr'); img._fsb = null; img._fsd = 0;
      img.removeAttribute('loading');
      if (ss) img.setAttribute('srcset', ss); else img.removeAttribute('srcset');
      img.setAttribute('src', src);
      if (img.getAttribute('alt')) img.setAttribute('alt', d.getAttribute('data-alt') || img.getAttribute('alt'));
    }
    Array.prototype.forEach.call(c.querySelectorAll('[data-fs-sw-d]'), function(x){ x.setAttribute('aria-pressed', x === d ? 'true' : 'false'); });
  }
  document.addEventListener('pointerover', function(e){
    if (e.pointerType !== 'mouse') return;
    var d = e.target.closest && e.target.closest('[data-fs-sw-d]'); if (!d) return;
    pick(d);
  });
  document.addEventListener('pointerout', function(e){
    if (e.pointerType !== 'mouse') return;
    var c = card(e.target); if (!c) return;
    if (e.relatedTarget && c.contains(e.relatedTarget)) return;
    var k = c._fsSwKeep || c.querySelector('[data-fs-sw-d][data-cur]');
    if (k) pick(k);
  });
  document.addEventListener('click', function(e){
    var d = e.target.closest && e.target.closest('[data-fs-sw-d]'); if (!d) return;
    e.preventDefault(); e.stopPropagation();
    var c = card(d); if (c) c._fsSwKeep = d;
    pick(d);
  });
  window.FSSw = { pick: pick };
})();

/* chips 17/10 — fila de atalhos da coleção: sombra + botão "›" à direita (desliza ~70%), sombra à esquerda depois de deslizar,
   no telemóvel o último atalho visível fica cortado a ~40% (ajusta o padding), o atalho ativo fica à vista,
   e um "empurrão" de 40px uma vez por sessão (sem prefers-reduced-motion). Só atua se a fila transbordar. */
(function(){
  'use strict';
  if (window.FSChips) return;
  var ES = (document.documentElement.lang || 'pt').slice(0,2) === 'es';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOB = window.matchMedia('(max-width:749px)');
  var KEY = 'fsChipsNudge';
  function seen(){ try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return true; } }
  function mark(){ try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function over(t){ return t.scrollWidth > t.clientWidth + 2; }
  function upd(w, t){
    var o = over(t), x = t.scrollLeft, max = t.scrollWidth - t.clientWidth;
    if (o && x > 4) w.setAttribute('data-l', ''); else w.removeAttribute('data-l');
    if (o && x < max - 4) w.setAttribute('data-r', ''); else w.removeAttribute('data-r');
  }
  /* telemóvel: padding (8–14px) e espaçamento das letras (.04–.14em) dos atalhos que deixam o 1.º atalho cortado com ~40% à vista */
  function fit(t){
    var chips = t.querySelectorAll('.fs-chip');
    if (!MOB.matches || chips.length < 2){ t.style.removeProperty('--fs-chip-px'); t.style.removeProperty('--fs-chip-ls'); return; }
    var cw = t.clientWidth, gap = parseFloat(getComputedStyle(t).columnGap) || 6, pl = parseFloat(getComputedStyle(t).paddingLeft) || 0;
    var best = [12, .12], bestD = 99;
    t.style.setProperty('--fs-chip-px', '0px');
    for (var ls = .04; ls < .145; ls += .02){
      t.style.setProperty('--fs-chip-ls', ls.toFixed(2) + 'em');
      var base = [];
      for (var i = 0; i < chips.length; i++) base.push(chips[i].getBoundingClientRect().width);
      for (var p = 8; p <= 14; p += .5){
        var x = pl, d = 99;
        for (var j = 0; j < base.length; j++){
          var w = base[j] + 2 * p;
          if (x + w > cw){ var f = (cw - x) / w; d = Math.abs(f - .4) + ((f < .25 || f > .6) ? 5 : 0); break; }
          x += w + gap;
        }
        d += .002 * Math.abs(p - 11) + .2 * Math.abs(ls - .1);
        if (d < bestD){ bestD = d; best = [p, ls]; }
      }
    }
    t.style.setProperty('--fs-chip-px', best[0] + 'px');
    t.style.setProperty('--fs-chip-ls', best[1].toFixed(2) + 'em');
  }
  function active(t){
    var a = t.querySelector('[aria-current="true"]'); if (!a) return;
    var tr = t.getBoundingClientRect(), ar = a.getBoundingClientRect();
    if (ar.left >= tr.left && ar.right <= tr.right - 40) return;
    var sb = t.style.scrollBehavior; t.style.scrollBehavior = 'auto';
    t.scrollLeft += (ar.left - tr.left) - (tr.width - ar.width) / 2;
    t.style.scrollBehavior = sb;
  }
  function nudge(w, t){
    if (RM || seen() || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return;
        io.disconnect();
        if (seen() || !over(t)) return;
        mark();
        var x0 = t.scrollLeft;
        setTimeout(function(){
          t.scrollTo({ left: x0 + 40, behavior: 'smooth' });
          setTimeout(function(){ t.scrollTo({ left: x0, behavior: 'smooth' }); }, 450);
        }, 350);
      });
    }, { threshold: .9 });
    io.observe(t);
  }
  function init(t){
    if (t._fsch || !t.querySelector('.fs-chip')) return; t._fsch = 1;
    var w = document.createElement('div'); w.className = 'fs-chw';
    t.parentNode.insertBefore(w, t); w.appendChild(t);
    w.insertAdjacentHTML('beforeend', '<span class="fs-chw__f fs-chw__f--l" aria-hidden="true"></span><span class="fs-chw__f fs-chw__f--r" aria-hidden="true"></span>'
      + '<button type="button" class="fs-chw__b" tabindex="-1" aria-hidden="true" title="' + (ES ? 'Ver más' : 'Ver mais') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>');
    var b = w.querySelector('.fs-chw__b');
    b.addEventListener('click', function(){ t.scrollBy({ left: Math.round(t.clientWidth * .7), behavior: RM ? 'auto' : 'smooth' }); });
    var raf = 0;
    t.addEventListener('scroll', function(){ if (!raf) raf = requestAnimationFrame(function(){ raf = 0; upd(w, t); }); }, { passive: true });
    function all(){ fit(t); active(t); upd(w, t); }
    all();
    var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(all, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
    window.addEventListener('load', all);
    nudge(w, t);
  }
  function scan(){ Array.prototype.forEach.call(document.querySelectorAll('.fs-colbar .fs-toolbar'), init); }
  window.FSChips = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
